import React, { Fragment } from "react";
import { utils } from "../common/utils";
import { Breakpoint } from 'react-socks';
import { useTranslation } from 'react-i18next';
import ExtendedLink from "./ExtendedLink";
import Image from "./Image";
import CurrencyFormat from './CurrencyFormat';

export default function (props) {
    const { t } = useTranslation();
    const { order, settings } = props;
    if (!order)
        return <div />
    const taxes = !order.isProductPricesIncludeTax ?
        (
            <Fragment>
                <div className="px-2 py-1">{`+ ${t("Total PST Tax")}:`} <span className='text-medium'><CurrencyFormat value={order.totalPSTTaxValue} settings={settings} /></span></div>
                <div className="px-2 py-1">{`+ ${t("Total HSTGST Tax")}:`} <span className='text-medium'><CurrencyFormat value={order.totalHSTGSTTaxValue} settings={settings} /></span></div>
            </Fragment>) : <Fragment />;

    return (
        <Fragment>
            <Breakpoint small down>
                {order.orderDetails.map(o => {
                    return (
                        <div key={o.id} className="dropdown-product-item">
                            <ExtendedLink to={`/products/${o.product.id}`} className="dropdown-product-thumb mobile-product-thumb">
                                <Image src={o.product.thumbnail ? o.product.thumbnail : "img/no-image.jpg"}
                                    fallbackSrc="img/no-image.jpg"
                                    alt={o.product.title} />
                                {/*<img*/}
                                {/*    src={o.product.thumbnail ? o.product.thumbnail : "img/no-image.jpg"}*/}
                                {/*    alt={o.product.title}*/}
                                {/*/>*/}
                            </ExtendedLink>
                            <div className="dropdown-product-info">
                                <ExtendedLink to={`/products/${o.product.id}`} className="dropdown-product-title">
                                    {o.product.title}
                                    <small>x {o.quantity}</small>
                                </ExtendedLink>
                                <span><em>{t("Article No")}: </em> {o.product.stockItemCode}</span><br />
                                <span><em>{t("Price")}: </em> <CurrencyFormat value={o.totalCustomerPrice} settings={settings} /> </span><br />
                            </div>
                        </div>
                    );
                })}
            </Breakpoint>
            <Breakpoint medium up>
                <div className="table-responsive shopping-cart mb-0">
                    <table className="table">
                        <thead>
                            <tr>
                                <th>{t("Product Name")}</th>
                                <th className="text-center">{t("Subtotal")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {order.orderDetails.map(o => (
                                <tr key={o.id} >
                                    <td>
                                        <div className="product-item">
                                            <ExtendedLink
                                                to={`/products/${o.product.id}`}
                                                className="product-thumb product-thumb-sm"
                                            >
                                                <Image
                                                    src={o.product.thumbnail ? o.product.thumbnail : "img/no-image.jpg"}
                                                    fallbackSrc="img/no-image.jpg"
                                                    alt={o.product.title}
                                                />
                                            </ExtendedLink>
                                            <div className="product-info">
                                                <h4 className="product-title">
                                                    <ExtendedLink to={`/products/${o.product.id}`}>
                                                        {o.product.title}
                                                        <small>x {o.quantity}</small>
                                                    </ExtendedLink>
                                                </h4>
                                                <span><em>{t("Article No")}: </em> {o.stockItemCode}</span>
                                                {o.variations.map(v => (<span key={v.variableStr + v.variationValue}><em>{v.variableStr}: </em> {v.variationValue}</span>))}
                                            </div>
                                        </div>
                                    </td>
                                    <td className="text-center text-lg text-medium"><CurrencyFormat value={o.totalCustomerPrice} settings={settings} /> </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </Breakpoint>
            <hr className="mb-3" />
            <div className="d-flex flex-wrap justify-content-between align-items-center pb-2">
                <div className="px-2 py-1">{t("Subtotal")}: <span className='text-medium'><CurrencyFormat value={order.totalCustomerPriceBeforeDiscountCode} settings={settings} /> </span></div>
                {order.hasDiscountCodes &&
                    <div className="px-2 py-1">{`- ${t("Discount")}:`} <span className='text-medium'><CurrencyFormat value={order.totalDiscountCodeAmount} settings={settings} /> </span></div>}

                <div className="px-2 py-1">{`+ ${t("Shipping")}:`} <span className='text-medium'><CurrencyFormat value={order.totalDeliveryFees} settings={settings} /> </span></div>
                {taxes}
                <div className="text-lg px-2 py-1">{`${t("Total")}:`} <span className='text-medium'><CurrencyFormat value={order.orderTotalAfterDiscount} settings={settings} /> </span></div>
            </div>
        </Fragment>
    );

}
